// <read-more-toggle> — expands a truncated block to its full content and back.
// Markup: a .read-more-toggle__truncated view, a .read-more-toggle__full view, and a
// [data-read-more-button] control. Labels come from data-more-label / data-less-label.
if (!customElements.get('read-more-toggle')) {
  customElements.define(
    'read-more-toggle',
    class ReadMoreToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-read-more-button]');
        if (!this.button || this.button.dataset.bound === 'true') return;
        this.button.dataset.bound = 'true';

        this.moreLabel = this.dataset.moreLabel || this.button.textContent.trim();
        this.lessLabel = this.dataset.lessLabel || 'Read less';

        if (this.getAttribute('expanded') == null) this.setAttribute('expanded', 'false');
        this.button.setAttribute('aria-expanded', this.getAttribute('expanded'));

        this.button.addEventListener('click', () => this.toggle());
      }

      toggle() {
        const expanded = this.getAttribute('expanded') === 'true';
        const next = expanded ? 'false' : 'true';
        this.setAttribute('expanded', next);
        this.button.setAttribute('aria-expanded', next);
        this.button.textContent = expanded ? this.moreLabel : this.lessLabel;
      }
    }
  );
}
